module.exports = __webpack_public_path__ + "img/rank-touxiang2.7fdbfce8.png";